export default function (){return [
    {icon: 'fa-address-book', text: 'Overview', to: '/overview'},
    {icon: 'fa-chart-bar', text: 'KPI', to: '/aa-kpi'},
    {icon: 'fa-history', text: 'Cooling Load', to: '/automated/cooling-load'},
    {icon: 'fa-bell', text: 'Notification Breakdown', to: '/notification-breakdown'},
    {icon: 'fa-calendar-alt', text: 'Monthly Report', to: '/aa-report'},
    {
        icon: 'fa-angle-up',
        'icon-alt': 'fa-angle-down',
        text: 'Plots',
        model: false,
        children: [
            {icon: 'fa-chart-bar', text: 'Simple Plots', to: '/sensors'},
            {icon: 'fa-chart-line', text: 'Time Series Plots', to: '/multiplots'},
            {icon: 'fa-chart-line', text: 'Equipment Plots', to: '/equipment-plots'},
            {icon: 'fa-layer-group', text: 'Facet Plots', to: '/plot/facet'},
        ]
    },
    {icon: 'fa-bell', text: 'Fault Detection', to: '/fault'},
    {icon: 'fa-bell', text: 'Fault Detection (Machine Learning)', to: '/modelsummary'},
    {
        icon: 'fa-angle-up',
        'icon-alt': 'fa-angle-down',
        text: 'Diagnostics',
        model: false,
        children: [
            {
                "text": "Pumps Speed Control & Staging",
                "to": "/automated/pumps"
            },
            {
                "text": "Pumps Runtime",
                "to": "/aa-pump-runtime"
            },
            {
                "text": "AHUs Runtime",
                "to": "/aa-ahu-runtime"
            },
            {
                "text": "AHU Temp & Speed Controls",
                "to": "/aa-ahu-controls"
            },
            {
                "text": "AHU Damper Controls",
                "to": "/aa-ahu-damper"
            },
        ]
    },
    {icon: 'fa-thermometer-half', text: 'Control Logic Benefit', to: '/controllogic'},
    {
        icon: 'fa-angle-up',
        'icon-alt': 'fa-angle-down',
        text: 'Config',
        model: false,
        children: [
            {icon: 'fa-tools', text: 'Equipments', to: '/equipments'},
            {icon: 'fa-building', text: 'Facilities', to: '/facility'},
            {icon: 'fa-bell', text: 'Anomaly Descriptions', to: '/anomaly-description'},
            {icon: 'fa-broadcast-tower', text: 'Points', to: '/points'},
            {icon: 'fa-cog', text: 'Config', to: '/config'},
            {icon: 'fa-ruler-horizontal', text: 'Parameter', to: '/parameter'},
            {icon: 'fa-chart-line', text: 'KPI', to: '/KPI'},
            {icon: 'fa-sliders-h', text: 'Settings', to: '/settings'},
            {icon: 'fa-mail-bulk', text: 'Report', to: '/report'},
            {icon: 'fa-align-justify', text: 'Rules', to: '/rules'},
            {icon: 'fa-users', text: 'Users', to: '/users'},
            {icon: 'fa-download', text: 'Export Data', to: '/viewdata'}
        ]
    },
    {icon: 'fa-notes-medical', text: 'Maintenance Record', to: '/maintenancerecord'},
    {icon: 'fa-question', text: 'Help', to: '/help'}
]}